import IntegratedAppEmbedder from './IntegratedAppEmbedder';
import IntegratedAppOptions from './IntegratedAppOptions';
import FormsAppOptions from './features/forms/FormsAppOptions';
import GoogleWorkspaceAppOptions from './features/google-workspace-app/GoogleWorkspaceAppOptions';
import LiveChatAppOptions from './features/livechat/LiveChatAppOptions';
import PluginAppOptions from './features/plugin/PluginAppOptions';
const w = window;
w.IntegratedAppEmbedder = IntegratedAppEmbedder;
w.IntegratedAppOptions = IntegratedAppOptions;
w.FormsAppOptions = FormsAppOptions;
w.LiveChatAppOptions = LiveChatAppOptions;
w.PluginAppOptions = PluginAppOptions;
w.GoogleWorkspaceAppOptions = GoogleWorkspaceAppOptions;
export * from './IntegratedAppEmbedder';
export * from './IntegratedAppOptions';
export * from './features';
export * from './constants';